import React, { useEffect } from 'react'
import { FaYoutube,FaInstagram,FaFacebook,FaLinkedin } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { IoMail } from "react-icons/io5";
import { FaSquareXTwitter } from "react-icons/fa6";
import { BsTwitterX } from "react-icons/bs";
function Footer() {
    const navigate = useNavigate();
    // useEffect(() => {
    //     const handleScrollToTop = () => {
    //       window.scrollTo({ top: 0, behavior: 'smooth' });
    //     };
    
    //     // Attach the event listener to the navigation
    //     navigate(handleScrollToTop);
    
    //     // Clean up the event listener when the component unmounts
    //     return () => {
    //       window.removeEventListener('scroll', handleScrollToTop);
    //     };
    //   }, [navigate]);

    const services = [
        {
            title: 'Business Management',
            to: '/business-management',
            subtitle: [
                {
                link: '',
                name: 'Overview',

            },
            {
                link: '',
                name: 'Store Management',

            },
            {
                link: '',
                name: 'Chat Segmentation ',

            },
            {
                link: '',
                name: 'Business Questions',

            },
            {
                link: '',
                name: 'Competitor Analysis',

            },
            {
                link: '',
                name: 'Locatization',

            },
            {
                link: '',
                name: 'Business Profile / Listings',

            },
            {
                link: '',
                name: 'Bookings',

            },
            

        
        ]

    },
        {
            title: 'Review Management',
            link: 'review',
            to: '/reviews-management',

            subtitle: [
                {
                link: '',
                name: 'Overview',

            },
            {
                link: '',
                name: 'Review Replies',

            },
            {
                link: '',
                name: 'Review Analysis',

            },
            {
                link: '',
                name: 'Business Questions',

            },
            {
                link: '',
                name: 'Competitor Analysis',

            },
            {
                link: '',
                name: 'Automated Responses',

            },
            

        
        ]

    },
    {
        title: 'Social Media Management',
        to: '/social-management',

        subtitle: [
            {
            link: '',
            name: 'Overview',

        },
        {
            link: '',
            name: 'Compose',

        },
        {
            link: '',
            name: 'Monitoring & Analyzing',

        },
        {
            link: '',
            name: 'Calendar Planner',

        },
        {
            link: '',
            name: 'Posts',

        },
        {
            link: '',
            name: 'Comments',

        },
        

    
    ]

},
{
    title: 'Marketing Management',
    to: '/marketing-management',

    subtitle: [
        {
        link: '',
        name: 'Overview',

    },
    {
        link: '',
        name: 'Personalized Marketing',

    },
    {
        link: '',
        name: 'Sms Campaign',

    },
    {
        link: '',
        name: 'Whatsapp Campaign',

    },
    {
        link: '',
        name: 'Email Campaign',

    },
    {
        link: '',
        name: 'Messaging Templates',

    },
    {
        link: '',
        name: 'Customer Contacts',

    },
    


]

},
{
    title: 'Messaging Management',
    to: '/messaging-management',
    subtitle: [
        {
        link: '',
        name: 'Overview',

    },
    {
        link: '',
        name: 'Omnichannel Inbox',

    },
    {
        link: '',
        name: 'NLP Segmentation',

    },
    {
        link: '',
        name: 'Automated Responses',

    },
    {
        link: '',
        name: 'Chatbots',

    },
    {
        link: '',
        name: 'Contact Management',

    },
    {
        link: '',
        name: 'Personalisation',

    },
    {
        link: '',
        name: 'Team Chat',

    },
    {
        link: '',
        name: 'Employee Assignment',

    },
    


]

},
{
    title: 'Ticketing Management',
    to: '/ticketing-management',

    subtitle: [
        {
        link: '',
        name: 'Overview',

    },
    {
        link: '',
        name: 'Analytics',

    },
    {
        link: '',
        name: 'Custom Integration',

    },
    {
        link: '',
        name: 'Customer Complaints',

    },
    {
        link: '',
        name: 'Reviews & Feedbacks',

    },
    {
        link: '',
        name: 'Ticket Automation',

    },
    {
        link: '',
        name: 'Dedicated KM Assignment',

    },
    


]

},
{
    title: 'Contact Center Management',
    to: '/contact-center',

    subtitle: [
        {
        link: '',
        name: 'Monitor Business Calls',

    },
    {
        link: '',
        name: 'Front Desk Management',

    },
    {
        link: '',
        name: 'Omnichannel',

    },
    {
        link: '',
        name: 'VoIP',

    },
    {
        link: '',
        name: 'Business Phone',

    },
    {
        link: '',
        name: 'Interaction Analysis',

    },
    {
        link: '',
        name: 'Virtual Assistant',

    },
    {
        link: '',
        name: 'Ai CSAT',

    },
    


]

},
{
    title: 'Ads Personalization',
    to: '/ad-management',
    subtitle: [
        {
        link: '',
        name: 'Overview',

    },
    {
        link: '',
        name: 'Personalized Ads',

    },
    {
        link: '',
        name: 'Localization',

    },
    {
        link: '',
        name: 'Multichannel Publication',

    },
    {
        link: '',
        name: 'Scheduling',

    },
    


]

},
{
    title: 'Payments',
    to: '/payments',
    subtitle: [
        {
        link: '',
        name: 'Analytics',

    },
    {
        link: '',
        name: 'Multiple channel acceptance',

    },
    {
        link: '',
        name: '1:1 Personalised Requests',

    },
    {
        link: '',
        name: 'Terminal Integration',

    },
    {
        link: '',
        name: 'Security',

    },
    


]

},
{
    title: 'AI is here',
    to: '/',
    subtitle: [
        {
        link: '',
        name: 'Analytics',

    },
    {
        link: '',
        name: 'Your Business Co-pilot',

    },
    {
        link: '',
        name: 'Automate Everything',

    },
    {
        link: '',
        name: 'Ask Anything',

    },
    // {
    //     link: '',
    //     name: 'Security',

    // },
    


]

},
]
  return (
    <div className='w-full bg-[#fafafa] flex flex-col h-max py-[60px] items-center'>
        <div className='w-[80%]'>
    <div className='bold text-[20px] sm:text-[26px] lg:text-[32px]'>
        Let's know more about Elyzian.
    </div>
    <div className='mt-10 lg:mt-[70px]'>
        <div className=' flex flex-wrap gap-12 sm:gap-10 lg:gap-20 xl:gap-[60px] 2xl:gap-36'>
            {services.map((e)=> (
                 <div className='flex flex-col gap-5 min-w-[230px]'>
                 <div onClick={() => navigate(`${e?.to}`)} className='semibold text-base cursor-pointer hover:underline'>
                    {e.title}
                 </div>
                 <div  className='flex flex-col gap-3'>
                    {e?.subtitle?.map((el) =>(  <div onClick={() => navigate(`${e?.to}`)} className='text-sm hover:underline cursor-pointer'>
                     {el.name}
                 </div>))}
               
                 
                 </div>
             </div>
            ))}
       
        </div>

    </div>
    <div className='h-[70px] border-y mt-12 flex items-center'>
        <div className='flex justify-between w-full'>
     <div className='flex gap-[4px] text-[20px] sm:text-[24px] lg:text-[30px] items-center aspect-auto'>
     <FaYoutube /> <FaInstagram /><FaFacebook /><FaLinkedin />
     <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" className='w-[20px] sm:w-[24px] lg:w-[30px]' viewBox="0 0 50 50">
<path d="M 11 4 C 7.134 4 4 7.134 4 11 L 4 39 C 4 42.866 7.134 46 11 46 L 39 46 C 42.866 46 46 42.866 46 39 L 46 11 C 46 7.134 42.866 4 39 4 L 11 4 z M 13.085938 13 L 21.023438 13 L 26.660156 21.009766 L 33.5 13 L 36 13 L 27.789062 22.613281 L 37.914062 37 L 29.978516 37 L 23.4375 27.707031 L 15.5 37 L 13 37 L 22.308594 26.103516 L 13.085938 13 z M 16.914062 15 L 31.021484 35 L 34.085938 35 L 19.978516 15 L 16.914062 15 z"></path>
</svg>
     </div>
     <div className='flex items-center gap-1 semibold'><IoMail /> support@elyzian.in</div>
     </div>
    </div>
    <div className='flex sm:flex-row flex-col items-center gap-1 text-[14px] medium justify-between mt-2'>
        <div className="medium">ELI8 COMMUCATIONS AND INFOTECH LLP</div>
        <div className='flex items-center gap-1 text-[14px] medium'>
        <img width="30" height="30" className='rounded-md' src="https://img.icons8.com/color/48/india.png" alt="india"/>Proudly built in India</div>
        </div>
    </div>
    </div>
  )
}

export default Footer
